<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <el-form :inline="true" label-position="right" label-width="150px" :model="stationDetailData">
          <el-form-item label="电站ID" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.id }}</div>
          </el-form-item>
          <el-form-item label="电桩总功率" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.sumPower }}</div>
          </el-form-item>
          <el-form-item label="电站地址" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.address }}</div>
          </el-form-item>
          <el-form-item label="场地坐标" class="width48">
            <div class="ml-80 notWrap">{{ 'E' + String(stationDetailData.stationLng) + '，' + 'N' + String(stationDetailData.stationLat) }}</div>
          </el-form-item>
          <el-form-item label="运营商" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.operationName }}</div>
          </el-form-item>
          <el-form-item label="电站类型" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.stationTypeValue }}</div>
          </el-form-item>
          <el-form-item label="建设场所" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.constructionValue }}</div>
          </el-form-item>
          <el-form-item label="停车说明" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.parkInstruction }}</div>
          </el-form-item>
          <el-form-item label="开放时间说明" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.busineHoursInstruction }}</div>
          </el-form-item>
          <el-form-item label="车位数量" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.carNumber }}</div>
          </el-form-item>
          <el-form-item label="备注说明" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.remark || "--" }}</div>
          </el-form-item>
          <el-form-item label="启停状态" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.disable ? "停用":"启用" }}</div>
          </el-form-item>
          <el-form-item label="电站更新时间" class="width48">
            <div class="ml-80 notWrap">{{ stationDetailData.updateTime }}</div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电单价</span>
      </div>
      <el-table :data="stationDetailData.feeDetail" stripe>
        <el-table-column label="序号" width="150">
          <template slot-scope="{ row,$index }">
            <div>{{ $index+1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="时段" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.timePriod }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="eleMoney" label="电费（元/度）" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.elecFee }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="serverMoney" label="服务费（元/度）" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.serviceFee }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">终端列表</span>
      </div>
      <el-table :data="stationDetailData.connectorList" stripe>
        <el-table-column label="序号" width="150">
          <template slot-scope="{ row,$index }">
            <div>{{ $index+1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="设备ID" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.connectorId }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="eleMoney" label="接口名称" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.connectorName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="serverMoney" label="接口类型" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.connectorType==3 ? '交流接口' : row.connectorType == 4 ? '直流接口' : '未知' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="serverMoney" label="额定功率（kW）" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.power }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="serverMoney" label="工作状态" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.status }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import times from './data.json'
export default {
  name: 'Dianzhanxiangqing',
  components: {},
  id: '',
  data() {
    return {
      stationDetailData: {},
      // 充电单价表格数据
      priceTableData: [
        {
          time: '00:00:00至23:59:59',
          eleMoney: '3.7700',
          serverMoney: '0.7700'
        },
        {
          time: '16:00:00至17:59:59',
          eleMoney: '8.7700',
          serverMoney: '1.7700'
        }
      ],
      // 终端列表表格数据
      listTableData: [
        {
          time: '00:00:00至23:59:59',
          eleMoney: '3.7700',
          serverMoney: '0.7700'
        },
        {
          time: '16:00:00至17:59:59',
          eleMoney: '8.7700',
          serverMoney: '1.7700'
        }
      ]
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.id = this.$route.query.data
      this.$store.dispatch('form/handle', {
        url: '/station/hlht/detail?stationId=' + this.id,
        method: 'get',
        callback: (resp) => {
          console.log('-------->', resp)
          this.stationDetailData = resp
        }
      })
    })
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" src="" scoped>
  .width48{
    width: 48%;
  }
  .notWrap{
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
  .ml-80{
    margin-left: 80px;
  }
  .width90{
    width: 90%;
    display: flex;
    /deep/.el-form-item__content{
      flex: 1;
    }
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .btns{
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/.el-table__header{
    width: 100% !important;
  }
  /deep/.el-table__body{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/InterConStationDetail.vue